module.exports = __webpack_public_path__ + "../static/img/base_switch.c3d2f5b5.png";